import { Bot } from 'lucide-react';

const TypingIndicator = () => {
  return (
    <div className="flex items-start space-x-3">
      <div className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 bg-gradient-to-br from-[#D4A5A5] to-[#BA7B7C] text-white">
        <Bot className="w-4 h-4" />
      </div>
      <div className="bg-[#F5F0EB] rounded-2xl rounded-bl-md px-4 py-3">
        <div className="flex items-center space-x-1.5">
          <div className="w-2 h-2 bg-[#BA7B7C] rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <div className="w-2 h-2 bg-[#BA7B7C] rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <div className="w-2 h-2 bg-[#BA7B7C] rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
